var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a1a2a9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.486)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.01 1.486)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.437,3.241,42.929,1.722a.8.8,0,0,0-1.131,0L31.524,12.067s0,.006-.006.009a.259.259,0,0,0-.045.069l-.009.018s0,.006,0,.009l-1.131,3.418a.269.269,0,0,0,.171.339.265.265,0,0,0,.166,0l3.394-1.139s.006,0,.009,0l.018-.009a.257.257,0,0,0,.068-.046l.009-.006L44.437,4.38A.809.809,0,0,0,44.437,3.241ZM31,15.25l.827-2.5,1.653,1.665Zm2.973-1.094-1.886-1.9,8.389-8.446.754.76L36.238,9.6a.27.27,0,0,0-.007.38.265.265,0,0,0,.377.007l.007-.007L41.609,4.95l.754.759ZM44.06,4,42.74,5.33,41.8,4.381l-.944-.95L42.175,2.1a.265.265,0,0,1,.377,0L44.06,3.621A.27.27,0,0,1,44.06,4Z",
    transform: "translate(-30.315 -1.486)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.733,462.513H.267a.267.267,0,1,0,0,.533H15.733a.267.267,0,1,0,0-.533Z",
    transform: "translate(0 -462.513)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.467 15.353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.267,414.513h-8a.267.267,0,0,0,0,.533h8a.267.267,0,0,0,0-.533Z",
    transform: "translate(-224 -414.513)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.533 13.464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.2,358.513h-6.933a.267.267,0,0,0,0,.533H263.2a.267.267,0,1,0,0-.533Z",
    transform: "translate(-256 -358.513)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.d6fcc77016287c9483c80b03f0e9d5de.svg";
export { ForwardRef as ReactComponent };